import { useEffect, useMemo } from "react";
import { RouterProvider } from "react-router-dom";

import { configureRequestsLibrary } from "@js/configure";

import { ErrorBoundary } from "./components/error-boundary";
import { parseFrontendRoutes } from "./routes/gather-routes";
import { setFrontendRoutes } from "./routes/get-frontend-routes";
import { getRouter, routes } from "./routes";

import "@braintrust/braintrust-ui-components/braintrust-ui-components.css";

/*
    Check also ./js/apps/common/views/app.tsx
*/

setFrontendRoutes(parseFrontendRoutes(routes()));

const App = () => {
  const router = useMemo(() => getRouter(), []);

  useEffect(() => {
    configureRequestsLibrary(router);
  }, [router]);
  return (
    <ErrorBoundary>
      <RouterProvider
        router={router}
        // The flag below breaks the navigation; for example, the redirect after closing the bid success modal takes a very long time.
        // future={{
        //   v7_startTransition: true,
        // }}
      />
    </ErrorBoundary>
  );
};

export default App;
